export default "__VITE_ASSET__CmRdzE2o__"